var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPriceTag2Fill = function SvgPriceTag2Fill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.4 7.5 12 2.433a.9.9 0 0 1 1 0L20.6 7.5v12.6a.9.9 0 0 1-.9.9H5.3a.9.9 0 0 1-.9-.9zm8.1 3.6a1.8 1.8 0 1 0 0-3.6 1.8 1.8 0 0 0 0 3.6m-3.6 4.5v1.8h7.2v-1.8zm0-2.7v1.8h7.2v-1.8z"
  })));
};
export default SvgPriceTag2Fill;